import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpRequest, HttpEventType, HttpResponse } from '@angular/common/http';
import { StoredFile } from '../model/file';
// import { AppModule } from '../app.module';
import { Observable, Subject, of, Subscription } from 'rxjs';
import { Constants } from '../Constants';
import { tap } from 'rxjs/operators';

@Injectable()
export class FileProvider {

    constructor(private http: HttpClient) { }

    public getExtension(file: StoredFile | { filename: string, size: number }): string {
        if (file && file.filename && file.size > 0) {
            return file.filename.slice(file.filename.lastIndexOf('.') + 1);
        }
        if (file) {
            return 'folder';
        }
        return null;
    }

    /*public exploreFiles(path: string, resource: string): Promise<StoredFile[]> {

        let params: HttpParams = new HttpParams();
        if (path)
            params = params.append('p', path);
        if (resource)
            params = params.append('res', resource);

        return this.http.get(Constants.protocol + Constants.fileServer + '/explore?' + params, Constants.httpOptions)
        .toPromise()
        .then(json => {
            let data: StoredFile[] = [];
            if (json && json['hits']) {
                for(let item of json['hits']) {
                    let f = new StoredFile().read(item);
                    f.is_dir = !(f.size > 0);
                    data.push(f);
                }
            }
            if (json && json['folders']) {
                for(let item of json['folders']) {
                    let f = new StoredFile().read(item);
                    f.is_dir = true;
                    data.push(f);
                }
            }
            if (json && json['files']) {
                for(let item of json['files']) {
                    let f = new StoredFile().read(item);
                    f.is_dir = false;
                    data.push(f);
                }
            }
            return data;
        });
    }*/

    public getFolders(folder: number, resource: string): Promise<StoredFile[]> {

        let params: HttpParams = new HttpParams();
        if (folder)
            params = params.append('folder', '' + folder);
        if (resource)
            params = params.append('res', resource);

        return this.http.get(Constants.protocol + Constants.fileServer + '/folders?' + params, Constants.httpOptions)
            .toPromise()
            .then(json => {
                let data: StoredFile[] = [];
                if (json && json['hits']) {
                    for (let item of json['hits']) {
                        let f = new StoredFile().read(item);
                        f.is_dir = true;    //!(f.size > 0);
                        data.push(f);
                    }
                }
                return data;
            });
    }

    public getFileMetaData(guid: string): Promise<StoredFile> {
        if (!guid || !guid.trim().length) {
            return new Promise<StoredFile>((resolve, reject) => reject(null));
        }

        let params: HttpParams = new HttpParams();
        params = params.append('guid', guid);

        return this.http.get(Constants.protocol + Constants.fileServer + '/files?' + params, Constants.httpOptions)
            .toPromise()
            .then(json => {
                if (json && json['hits'] && json['hits'].length) {

                    let f = new StoredFile().read(json['hits'][0]);
                    f.is_dir = !(f.size > 0);
                    return f;
                }
                return null;
            });
    }

    public getFiles(folder: number, resource: string, path?: string): Promise<StoredFile[]> {

        let params: HttpParams = new HttpParams();
        if (folder)
            params = params.append('folder', '' + folder);
        if (resource)
            params = params.append('res', resource);
        if (path)
            params = params.append('path', path);

        return this.http.get(Constants.protocol + Constants.fileServer + '/files?' + params, Constants.httpOptions)
            .toPromise()
            .then(json => {
                let data: StoredFile[] = [];
                if (json && json['hits']) {
                    for (let item of json['hits']) {
                        let f = new StoredFile().read(item);
                        f.is_dir = !(f.size > 0);
                        data.push(f);
                    }
                }
                if (json && json['folders']) {
                    for (let item of json['folders']) {
                        let f = new StoredFile().read(item);
                        f.is_dir = true;
                        data.push(f);
                    }
                }
                if (json && json['files']) {
                    for (let item of json['files']) {
                        let f = new StoredFile().read(item);
                        f.is_dir = false;
                        data.push(f);
                    }
                }
                return data;
            });
    }

    public searchFiles(query: string, byContent: boolean): Promise<any> {

        let params: HttpParams = new HttpParams();
        params = params.append('q', query);
        if (byContent) {
            params = params.append('content', '');
        }

        return this.http.get(Constants.protocol + Constants.fileServer + '/search?' + params, Constants.httpOptions)
            .toPromise()
            .then(json => {
                return json;
                // let data: File[] = [];
                // if (json && json['hits']) {
                //     for(let item of json['hits']) {
                //         let f = new File().read(item);
                //         f.is_dir = (f.size > 0);
                //         data.push(f);
                //     }
                // }
                // if (json && json['suggestions']) {
                //     for(let item of json['suggestions']) {
                //         let f = new File().read(item);
                //         f.is_dir = false;
                //         data.push(f);
                //     }
                // }
                // return data;
            });
    }

    getFolder(folder: number): Promise<StoredFile> {
        // newFolder(path: string, resource: string): Promise<boolean> {
        let params: HttpParams = new HttpParams();
        if (folder) {
            params = params.append("folder", '' + folder);
        } else {
            return null;
        }

        let url = Constants.protocol + Constants.fileServer + '/folder';

        return this.http.get(url + '?' + params, Constants.httpOptions)
            .toPromise()
            .then(res => {
                if (res) {
                    return new StoredFile().read(res);
                } else {
                    return null;
                }
            });
    }

    newFolder(folder: number, name: string, resource: string): Promise<number> {
        debugger;
        // newFolder(path: string, resource: string): Promise<boolean> {
        let params: HttpParams = new HttpParams();
        if (folder) {
            params = params.append("folder", '' + folder);
        }
        params = params.append("name", name);
        params = params.append("resource", resource);

        let url = Constants.protocol + Constants.fileServer + '/folder/add';

        return this.http.post(url + '?' + params.toString(), null, Constants.httpOptions)
            .toPromise()
            .then(res => {
                return res['id'];
            });
    }

    public rename(kind: string, guid: string, name: string, newname: string, res: string, infolder: number) {
        let params: HttpParams = new HttpParams();
        params = params.append("guid", guid);
        params = params.append("name", name);
        params = params.append("newname", newname);
        if (res) params = params.append("res", res);
        if (infolder) params = params.append("folder", infolder.toString());

        let url = Constants.protocol + Constants.fileServer + '/' + kind + '/rename';

        return this.http.post(url + '?' + params.toString(), null, Constants.httpOptions)
            .toPromise()
            .then(res => {
                return true;
            });
    }

    public delete(kind: string, guid: string, name: string, res: string, infolder: number): Promise<boolean> {
        let params: HttpParams = new HttpParams();
        params = params.append("guid", guid);
        params = params.append("name", name);
        if (res) params = params.append("res", res);
        if (infolder) params = params.append("folder", infolder.toString());

        let url = Constants.protocol + Constants.fileServer + '/' + kind + '/delete';

        return this.http.delete(url + '?' + params, Constants.httpOptions)
            .toPromise()
            .then(res => {
                return true;
            });
    }

    public move(file: StoredFile, toFolder: StoredFile, res: string): Promise<boolean> {

        const url = Constants.protocol + Constants.fileServer + '/file/move';

        let data = {
            guid: file.guid,
            folder: (toFolder) ? toFolder.id : "root",
            res: res
        }

        return this.http.post(url, data, Constants.httpOptions)
            .toPromise()
            .then(res => true)
            .catch(err => null)
    }

    public share(data: { files: string[], resources: string[] }): Promise<boolean> {

        const url = Constants.protocol + Constants.fileServer + '/file/share';

        return this.http.post(url, data, Constants.httpOptions)
            .toPromise()
            .then(res => true)
            .catch(err => null)
    }

    public lookupUsers(name: String): Observable<any[]> {
        if (!name) {
            return of([]);
        }

        let url = Constants.protocol + Constants.identityServer + '/user';
        const formData = new FormData();
        formData.append('search', '' + name);
        formData.append('request_action', "1");
        return this.http.post(url, formData, { withCredentials: true })//Constants.httpOptions
            .pipe(
                tap((response: any) => {

                    let users = [];
                    let ids = new Map<number, any>();
                    if (response && response.users) {
                        for (let u of response.users) {
                            if (u.username || u.email) {
                                ids.set(u.id, u);
                            }
                        }
                        ids.forEach((value, key) => {
                            users.push(value);
                        });
                    }

                    response.users = users;
                })
            );
    }

    // private uploadOps: Map<File, Subscription> = new Map<File, Subscription>();

    public upload(files: Set<File>, path: string, folder: number, res: string): { [key: string]: { progress: Observable<number>, result: any } } {

        // public upload(files: Set<File>, path: string, res: string): { [key: string]: { progress: Observable<number> } } {

        const url = Constants.protocol + Constants.fileServer + '/file/upload';

        // this will be the our resulting map
        const status: { [key: string]: { progress: Observable<number>, result: any } } = {};

        files.forEach(file => {
            /*Nobel 2025-08-27*/
            if (file instanceof StoredFile) {
                return;
            }
            // create a new multipart-form for every file
            const formData: FormData = new FormData();

            if (folder) {
                formData.append('folder', '' + folder);
            }
            if (path) {
                formData.append('path', path);
            }
            formData.append('res', res);
            /*Nobel 2025-08-24*/
            debugger;
            formData.append("file", file, (file as any).filename || file.name);

            // create a http-post request and pass the form
            // tell it to report the upload progress
            const req = new HttpRequest("POST", url, formData, {
                reportProgress: true,
                withCredentials: true
            });

            // create a new progress-subject for every file
            const progress = new Subject<number>();

            // send the http-request and subscribe for progress-updates

            let startTime = new Date().getTime();
            let sub = this.http.request(req).subscribe(event => {
                if (event.type === HttpEventType.UploadProgress) {
                    // calculate the progress percentage

                    const percentDone = Math.round((100 * event.loaded) / event.total);
                    // pass the percentage into the progress-stream
                    progress.next(percentDone);
                } else if (event instanceof HttpResponse) {
                    // Close the progress-stream if we get an answer form the API
                    // The upload is complete
                    status[file.name].result = event.body;
                    progress.complete();
                }
            },
                error => {
                    status[file.name].result = 'Failed upload';
                    progress.next(0);
                    progress.error(error);
                });

            //   this.uploadOps.set(file, sub);
            //   sub.unsubscribe();

            // Save every progress-observable in a map of all observables
            status[file.name] = {
                progress: progress.asObservable(),
                result: null
            };
        });

        // return the map of progress.observables
        return status;
    }

    // public cancelUpload(file: File) {
    //     let sub = this.uploadOps.get(file);
    //     if (sub) {
    //         sub.unsubscribe();
    //         this.uploadOps.delete(file);
    //     }
    // }

    public updateFile(content: Blob, guid: string, filename: string, path: string, folder: number, res: string): { progress: Observable<number> } {

        // public upload(files: Set<File>, path: string, res: string): { [key: string]: { progress: Observable<number> } } {

        const url = Constants.protocol + Constants.fileServer + '/file/upload';

        // this will be the our resulting map
        const status: { progress: Observable<number> } = { progress: null };

        const formData: FormData = new FormData();

        if (folder) {
            formData.append('folder', '' + folder);
        }
        if (path) {
            formData.append('path', path);
        }
        formData.append('res', res);
        formData.append('guid', guid);
        formData.append("file", content, filename);

        // create a http-post request and pass the form
        // tell it to report the upload progress
        const req = new HttpRequest("POST", url, formData, {
            reportProgress: true,
            withCredentials: true
        });

        // create a new progress-subject for every file
        const progress = new Subject<number>();

        // send the http-request and subscribe for progress-updates

        let startTime = new Date().getTime();
        this.http.request(req).subscribe(event => {
            if (event.type === HttpEventType.UploadProgress) {
                // calculate the progress percentage

                const percentDone = Math.round((100 * event.loaded) / event.total);
                // pass the percentage into the progress-stream
                progress.next(percentDone);
            } else if (event instanceof HttpResponse) {
                // Close the progress-stream if we get an answer form the API
                // The upload is complete
                if (event.status == 200) {
                    progress.complete();
                } else {
                    progress.error(null);
                }
            }
        });

        // Save every progress-observable in a map of all observables
        status.progress = progress.asObservable();

        //});

        // return the map of progress.observables
        return status;
    }
    /*   
   public reUpload(content: Blob, filename: string, path: string, folder: number, res: string): { progress: Observable<number> } {

       // public upload(files: Set<File>, path: string, res: string): { [key: string]: { progress: Observable<number> } } {
       
           const url = Constants.protocol + Constants.fileServer + '/file/upload';
       
           // this will be the our resulting map
           const status: { progress: Observable<number> } = { progress: null };
       
               const formData: FormData = new FormData();
   
               if (folder) {
                   formData.append('folder', '' + folder);
               }
               if (path) {
                   formData.append('path', path);
               }
               formData.append('res', res);
               formData.append("file", content, filename);
       
             // create a http-post request and pass the form
             // tell it to report the upload progress
             const req = new HttpRequest("POST", url, formData, {
               reportProgress: true,
               withCredentials: true
             });
       
             // create a new progress-subject for every file
             const progress = new Subject<number>();
       
             // send the http-request and subscribe for progress-updates
       
             let startTime = new Date().getTime();
             this.http.request(req).subscribe(event => {
               if (event.type === HttpEventType.UploadProgress) {
                 // calculate the progress percentage
       
                 const percentDone = Math.round((100 * event.loaded) / event.total);
                 // pass the percentage into the progress-stream
                 progress.next(percentDone);
               } else if (event instanceof HttpResponse) {
                 // Close the progress-stream if we get an answer form the API
                 // The upload is complete
                 progress.complete();
               }
             });
       
             // Save every progress-observable in a map of all observables
             status.progress = progress.asObservable();
             
           //});
       
           // return the map of progress.observables
           return status;
   }
*/

    /*Nobel 2028-08-19 Shady*/
    downloadBlob(file: StoredFile | { filename: string, guid: string }): Promise<Blob> {
        if (file == null) return;

        var headers = new Headers();
        headers.append('Accept', '*/*');

        const options = ({ responseType: 'arraybuffer' as 'arraybuffer', withCredentials: true });       //, headers: headers, withCredentials: true });

        let params: HttpParams = new HttpParams();
        params = params.append("f", file.filename);
        params = params.append("guid", file.guid);

        let url = Constants.protocol + Constants.fileServer + '/file/download';

        // Process the file downloaded
        return this.http.get(url + '?' + params.toString(), options)
            .toPromise()
            .then(res => {
                debugger;
                return new Blob([new Uint8Array(res)], { type: 'application/octet-stream' });
            }).catch(err => {
                return null;
            });
    }

    download(file: StoredFile | { filename: string, guid: string }): Promise<boolean> {
        if (file == null) return;

        var headers = new Headers();
        headers.append('Accept', '*/*');

        const options = ({ responseType: 'arraybuffer' as 'arraybuffer', withCredentials: true });       //, headers: headers, withCredentials: true });

        let params: HttpParams = new HttpParams();
        params = params.append("f", file.filename);
        params = params.append("guid", file.guid);

        let url = Constants.protocol + Constants.fileServer + '/file/download';

        // Process the file downloaded
        return this.http.get(url + '?' + params.toString(), options)
            .toPromise()
            .then(res => {
                // console.log(res);
                this.writeContents(new Uint8Array(res), file.filename, 'application/octet-stream');
                // const fileName = getFileNameFromResponseContentDisposition(res);
                // saveFile(res.blob(), fileName);

                return true;
            }).catch(err => {
                return null;
            });
    }

    writeContents(content: Uint8Array, fileName: string, contentType: string) {
        const a = document.createElement('a');
        const file = new Blob([content], { type: contentType });
        a.href = URL.createObjectURL(file);
        a.download = fileName;
        a.click();
    }

    public downloadProgress(filename: string, guid: string): { progress: Observable<number>, array: Uint8Array } {

        // public upload(files: Set<File>, path: string, res: string): { [key: string]: { progress: Observable<number> } } {

        let url = Constants.protocol + Constants.fileServer + '/file/download';

        let params: HttpParams = new HttpParams();
        params = params.append("f", filename);
        params = params.append("guid", guid);

        url += '?' + params;

        // this will be the our resulting map
        const status: { progress: Observable<number>, array: Uint8Array } = { progress: null, array: null };

        // const formData: FormData = new FormData();

        // if (folder) {
        //     formData.append('folder', '' + folder);
        // }
        // if (path) {
        //     formData.append('path', path);
        // }
        // formData.append('res', res);
        // formData.append('guid', guid);
        // formData.append("file", content, filename);

        // create a http-post request and pass the form
        // tell it to report the upload progress
        const req = new HttpRequest("GET", url, {
            reportProgress: true,
            responseType: 'arraybuffer' as 'arraybuffer',
            observer: 'events',
            withCredentials: true
        });

        // create a new progress-subject for every file
        const progress = new Subject<number>();

        // send the http-request and subscribe for progress-updates

        let startTime = new Date().getTime();
        this.http.request(req).subscribe(event => {
            if (event.type === HttpEventType.DownloadProgress) {
                // calculate the progress percentage

                const percentDone = Math.round((100 * event.loaded) / event.total);
                // pass the percentage into the progress-stream
                progress.next(percentDone);

            } else if (event instanceof HttpResponse) {
                // Close the progress-stream if we get an answer form the API
                // The download is complete
                if (event.status == 200) {
                    progress.next(100);
                    status.array = event.body as Uint8Array;
                    progress.complete();
                } else {
                    progress.next(0);
                    progress.error(null);
                }
            }
        });

        // Save every progress-observable in a map of all observables
        status.progress = progress.asObservable();

        //});

        // return the map of progress.observables
        return status;
    }

}